import { toast } from "react-toastify";

function toastify(msg,type){
    toast(`${msg}`, {
        type: `${type}`,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
}
export default toastify